module.exports = __webpack_public_path__ + "img/unazimuthal-grid.896117c7.png";